// test2765
(2765 && 0);
